import React from 'react';
import { TrainerDialog } from './TrainerDialog';

export type TrainerConfirmDialogProps = {
  open: boolean;
  title: string;
  message: React.ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  danger?: boolean;
  confirming?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

/** Centered confirm dialog — shared trainer dialog shell. */
export function TrainerConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel = 'Cancel',
  danger = true,
  confirming = false,
  onConfirm,
  onCancel,
}: TrainerConfirmDialogProps) {
  return (
    <TrainerDialog
      open={open}
      role="alertdialog"
      title={title}
      titleId="trainer-confirm-title"
      description={message}
      size="md"
      showClose
      onClose={confirming ? undefined : onCancel}
      dismissOnScrim={!confirming}
      closeDisabled={confirming}
      footer={
        <>
          <button type="button" className="tr-btn-ghost" onClick={onCancel} disabled={confirming}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={danger ? 'tr-btn-danger--filled' : 'tr-btn-primary'}
            onClick={() => {
              void onConfirm();
            }}
            disabled={confirming}
          >
            {confirmLabel}
          </button>
        </>
      }
    />
  );
}
